//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      locationImg: require("../assets/location.png"),
      emailImg: require("../assets/email.png"),
      officialImg: require("../assets/officialUrl.png"),
      cellPhoneImg: require("../assets/cellPhone.png"),
      logoImg: require("../assets/logo.png"),
      storeLogo: "",
      id: "",
      activeId: "",
      disabled: false,
      showPositionValue: false,
      loading: false,
      errorMsg: "",
      addForm: {
        storeName: "",
        content: "",
        storeLogo: "",
        address: "",
        email: ""
      }
    };
  },
  computed: {},
  async mounted() {
    this.id = this.$route.params.id;
    this.activeId = this.$route.params.activeId;
    await this.queryInfo();
  },
  methods: {
    /**
     * 返回首页
     *
     */
    goback() {
      this.$router.push({
        name: "storelist",
        params: { activeId: this.activeId }
      });
    },
    /**
     * 获取所有活动信息
     *
     */
    async queryInfo(param = {}) {
      const getModel = this.$apis.exhibition.getStoreModel;
      try {
        const { data } =
          (await this.$axios.get(`${getModel}/${this.id}`)) || {};
        if (!data) {
          // 访问的活动不存在，返回到错误页面
          this.$router.push({ name: "error" });
        }
        this.addForm = data;
        this.storeLogo = data.storeLogo;
        console.log(data);
      } catch (err) {
        console.log(err);
        this.showMsg(err.data.msg);
      }
    },
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/storedetail.vue